import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    columns: []
}



const tableSlice = createSlice({
    name: 'table',
    initialState,
    reducers: {
        tableColumns: (state, action) => {
            state.columns = action.payload
        }
    }

})

export const { tableColumns } = tableSlice.actions;

export default tableSlice.reducer;